const isValidHex = (hex) => {
  const lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh;
};

export default isValidHex;
